export const BORDER_RADIUS = 4;
